import React from "react";
import { Flex } from "theme-ui";

import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

const selector = ({ remainingLiquidityMiningLQTYReward3 }: LiquityStoreState) => ({
  remainingLiquidityMiningLQTYReward3
});

export const RemainingLQTY: React.FC = () => {
  const { remainingLiquidityMiningLQTYReward3 } = useLiquitySelector(selector);

  return (
    <Flex sx={{ mr: 2, fontSize: 2, fontWeight: "medium" }}>
      {remainingLiquidityMiningLQTYReward3.prettify(0)} FLEX remaining
    </Flex>
  );
};